import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import Download from '../../atoms/icons/Download';
const StyledAttachment = styled.a `
    display: flex;
    align-items: center;
    padding: 10px;
    background-color: #f1f1f1;
    border: 1px solid #e6e6e6;
    border-radius: 6px;
    text-decoration: none;
    transition: all 100ms ease-in-out;

    &:hover {
        background-color: #e6e6e6;
    }
`;
const StyledDownload = styled(Download) `
    fill: ${props => props.theme.secondary};
    margin-right: 10px;
`;
const FileName = styled.span `
    display: block;
    color: ${props => props.theme.primary.base};
    width: 136px;
    font-size: 16px;
    font-weight: 400;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;
const Attachment = ({ href, fileName }) => {
    return (_jsxs(StyledAttachment, { href: href, children: [_jsx(StyledDownload, {}), _jsx(FileName, { children: fileName })] }));
};
export default Attachment;
